/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackRestrictionType {
    Adult,
    Blacklisted,
    DeviceRestricted,
    InHomeLocationError,
    InHomeLocationUnreachable,
    NetworkConnected,
    NetworkDisconnected,
    NoRestriction,
    OutOfHome,
    OutOfRegion,
    Unsubscribed,
}
